import { render, staticRenderFns } from "./Evenements.vue?vue&type=template&id=b2d30972&scoped=true"
import script from "./Evenements.vue?vue&type=script&lang=js"
export * from "./Evenements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d30972",
  null
  
)

export default component.exports